export default __webpack_public_path__ + "static/media/oct-6.556174ed.pdf";